/// <reference path="../_references.ts"/>

module App.Payment {
	import FinancePlan = App.Appointments.FinancePlan;
	export type PaymentTypeName = 'cash' | 'card' | 'check' | 'financing' | 'invoice';

	export type PaymentInfo = {
		id: number;
		finance_plan: FinancePlan;
		total: string;
		amount_due: string;
		payments: Payment[];
	};

	export type PaymentType = {
		id: number;
		name: PaymentTypeName;
		description: string;
	};

	export class Payment {
		id: number = null;
		amount: number = null;
		email_sent: boolean = true;
		payment_type: PaymentTypeName = 'cash';
		type?: string;
		date?: string;
		details: string = null;
		email: string = null;
		appointment: number = null;
		technician: {
			id: number;
			full_name: string;
		} | number = null;
		email_note: string = null;
		signature: string = null;
		print_name: string = null;
		license: string = null;
		billingAddress?: string;

		constructor(data?: Payment, email?: string, tech?: number, amountDue?: string) {
			data = data || this;

			const amount = amountDue ? parseFloat(amountDue.replace(',', '')) : data.amount;

			this.id = data.id;
			this.amount = amount > 0 ? amount : data.amount;
			this.email_sent = true;
			this.payment_type = data.payment_type;
			this.date = data.date;
			this.details = data.details;
			this.email = email || data.email;
			this.appointment = data.appointment;
			this.technician = tech || data.technician;
			this.email_note = data.email_note;
			this.signature = data.signature || null;
			this.print_name = data.print_name || null;
			this.license = data.print_name || null;
		}
	}

	export type PaymentData = {
		firstName: string;
		mI: string;
		lastName: string;
		billingAddress: string;
		postalCode: string;
	}
}